<template>
  <div>
    <div class="solution">
      <header-component  pageType="write" :menuIndex="1"/>
      <nav class="w-1000">
        <div class="nav-txt flex" data-aos="fade-up"><div class="txt1">{{ $t('solution6.nav.highlight') }}</div>{{ $t('solution6.nav.title') }}</div>
        <div class="nav-txt" data-aos="fade-up" data-aos-delay="100">{{ $t('solution6.nav.subtitle') }}</div>
        <div class="desc" data-aos="fade-up" data-aos-delay="200">{{ $t('solution6.nav.desc') }}</div>
        <div class="btn" data-aos="fade-up" data-aos-delay="300" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution6.nav.btn') }}</div>
      </nav>
    </div>
    <div class="content1 w-1000 flex flex-column flex-align-center">
      <div class="txt1" data-aos="fade-up">{{ $t('solution6.content1.title') }}</div>
      <div class="txt2" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution6.content1.desc')"></div>
      <div class="item flex flex-column flex-align-center" data-aos="fade-up" data-aos-delay="200">
        <img src="@/assets/image/solution6/Slice 47@2x.png"/>
        <div class="txt3">{{ $t('solution6.content1.item1.title') }}</div>
        <div class="txt4" v-html="$t('solution6.content1.item1.desc')"></div>
        <div class="connect" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution6.content1.item1.btn') }}</div>
      </div>
      <div class="item flex flex-column flex-align-center" data-aos="fade-up" data-aos-delay="100">
        <img src="@/assets/image/solution6/Slice 47@2x(1).png"/>
        <div class="txt3">{{ $t('solution6.content1.item2.title') }}</div>
        <div class="txt4">{{ $t('solution6.content1.item2.desc') }}</div>
        <div class="connect" @click="toKnowldedge">{{ $t('solution6.content1.item2.btn') }}</div>
      </div>
    </div>
    <connect-component ref="connectRef" @kf="$refs.connectRef.toConnectIndex()"></connect-component>
    <kf-component kf-top="1103px" ref="kfContainer"></kf-component>
  </div>
</template>
<script>
export default {
  name: 'solution1-page',
  data() {
    return {

    }
  },
  methods:{
    toKnowldedge () {
      window.open('https://share.fastgpt.in/chat/share?shareId=uy26bokfmw6wpi3baqfz7k2r', '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
.solution{
  min-height: 783px;
  background: url('@/assets/image/solution6/Slice 51@2x.png') no-repeat center/100% 100%;
}
nav {
  padding-top: 170px;

  .nav-txt {
    font-weight: bold;
    font-size: 60px;
    color: #000000;
    line-height: 90px;
    text-align: left;
    .txt1{
      color: #C085FF;
    }
  }
  .desc{
    max-width: 663px;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 20px;
    color: #8C898E;
    line-height: 40px;
    margin:30px 0  100px;
  }

  .btn {
    width: 196px;
    height: 46px;
    background: linear-gradient( 90deg, #C45DF5 0%, #5D57FF 100%);
    border-radius: 50px 50px 50px 50px;
    font-family: Inter, Inter;
    font-weight: normal;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 46px;
    letter-spacing: 3px;
    text-align: center;
    cursor: pointer;
  }
}
.content1{
  margin: 111px auto;
  .txt1{
    font-family: Inter, Inter;
    font-size: 40px;
    color: #000000;
    line-height: 60px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .txt2{
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 20px;
    color: #979797;
    line-height: 36px;
    text-align: center;
  }
  .item{
    width: 881px;
    min-height: 626px;
    margin-bottom: 50px;
    background: url('@/assets/image/solution6/Slice 48@2x.png') no-repeat center/100% 100%;
    img{
      width: 181px;
      height: 181px;
      margin-top: 100px;
    }
    .txt3{
      font-family: Poppins, Poppins;
      font-weight: bold;
      font-size: 20px;
      color: #2B2B2B;
      line-height: 23px;
      margin: 33px 0 38px;
    }
    .txt4{
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 16px;
      color: #808080;
      line-height: 22px;
      text-align: center;
      max-width: 418px;
    }
    .connect{
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 16px;
      line-height: 29px;
      letter-spacing: 6px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      background: linear-gradient(to right, #7859F8 0%, #AF68C0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-decoration-line: underline;
      margin-top: 50px;
      cursor: pointer;
    }
  }
}

</style>